module.exports = __webpack_public_path__ + "static/img/carousel_5_nx3ajx_ar_16_9_w_768.62f9fb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_5_nx3ajx_ar_16_9_w_768.jpg
// module id = fR3Q
// module chunks = 0